export default __webpack_public_path__ + "static/media/employees_7.f966d966.png";